/**
 * Lädt den Gratisversand-Schwellwert aus der (gecachten) Server-Route,
 * die ihn wiederum aus der Store API (Versandart-Preismatrix) ableitet.
 * Der Wert wird via useState app-weit geteilt und nur einmal geholt.
 */
export const useFreeShippingThreshold = () => {
  const threshold = useState<number | null>("freeShippingThreshold", () => null);

  async function loadFreeShippingThreshold() {
    if (threshold.value !== null) return threshold.value;
    try {
      const data = await $fetch<{ threshold: number | null }>(
        "/api/shipping/free-shipping-threshold",
      );
      if (typeof data?.threshold === "number") {
        threshold.value = data.threshold;
      }
    } catch (e) {
      // Bei Fehler bleibt der Wert null -> die Komponente nutzt ihren Fallback.
    }
    return threshold.value;
  }

  return { threshold, loadFreeShippingThreshold };
};
